import {createSelector} from "reselect";
import queryString from 'query-string';


const couriersUrlSelector = (props: any) => {
    return props.location.search
};

export const couriersCityIdReSelector = createSelector(
    [couriersUrlSelector],
    (queryParams) => {
        const getParams = queryString.parse(queryParams);
        return getParams.cityId ? +getParams.cityId : undefined
    }
);
